import { Fragment, useContext } from "react";
import { ImExit } from "react-icons/im";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import HamburgerMenuContext from "../../context/hamburgerMenuContext";
import style from "./NavbarSmall.module.css";
import Profile from "./components/Profile";
import useSharedData from "../../../../../hooks/useSharedData";

function NavbarSmall() {
  const navigate = useNavigate();

  const { hasAccess, isAuthed } = useSharedData();

  const { hambergerMenu, setHambergerMenu } = useContext(HamburgerMenuContext);

  const handleExit = () => {
    Swal.fire({
      icon: "error",
      title: "خروج",
      html: "<p style='font-size: 20px'>آیا مطمئن هستید ؟؟</p>",
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      confirmButtonColor: "red",
      customClass: "rtl",
      focusCancel: true,
      iconColor: "red",
    }).then(result => {
      if (result.isConfirmed) {
        navigate("/logout");
      }
    });
  };

  return (
    <div className="d-block d-xl-none">
      <Link to="/" className="w-auto h-auto">
        <img src="../logoTemp.png" className={style.logo} />
      </Link>

      <div
        className={
          "overflow-y-auto " +
          (hambergerMenu === true ? style.showSidebar : "") +
          " " +
          style.sidebar
        }
      >
        <Sidebar
          rtl={true}
          className={"color-avaex h-100 " + style.aside}
          width="290"
        >
          <Profile />
          <Menu>
            <MenuItem component={<Link to="/" />}>خانه</MenuItem>
            <SubMenu label="ثبت سفارش">
              <SubMenu label="سفارش داخلی">
                <MenuItem component={<Link to="/new/letter" />}>
                  آنلاین (پیشکرایه)
                </MenuItem>
                <MenuItem component={<Link to="/new/cod" />}>
                  پسکرایه (COD)
                </MenuItem>
                <MenuItem component={<Link to="/new/bulk" />}>
                  سفارش انبوه
                </MenuItem>

                {hasAccess(1) && (
                  <MenuItem component={<Link to="/shop" />}>
                    سفارش آوا شاپ
                  </MenuItem>
                )}

                {hasAccess(10) && (
                  <MenuItem component={<Link to="/vip" />}>سفارش ویژه</MenuItem>
                )}

                <MenuItem component={<Link to="/avabox" />}>
                  سفارش آوا باکس
                </MenuItem>
              </SubMenu>
              <MenuItem component={<Link to="/newex" />}>سفارش خارجی</MenuItem>
            </SubMenu>
            <MenuItem component={<Link to="/tracking" />}>رهگیری</MenuItem>

            <MenuItem component={<Link to="/guide" />}>راهنما</MenuItem>

            <SubMenu
              label="توسعه دهندگان"
              component={<Link to="/developers" />}
            >
              <MenuItem component={<Link to="/developers/web-service" />}>
                وب سرویس (API)
              </MenuItem>
              <MenuItem component={<Link to="/developers/plugin" />}>
                پلاگین وردپرسی
              </MenuItem>
              <MenuItem component={<Link to="/developers/php-package" />}>
                پکیج PHP
              </MenuItem>
              <MenuItem component={<Link to="/developers/digi-extension" />}>
                اکستنشن دیجی کالا
              </MenuItem>
            </SubMenu>

            {isAuthed && (
              <SubMenu label="حساب من">
                <MenuItem component={<Link to="/account" />}>پروفایل</MenuItem>
                <MenuItem component={<Link to="/prewallet" />}>
                  کیف پول
                </MenuItem>
                <MenuItem component={<Link to="/myletters" />}>
                  مرسولات من
                </MenuItem>
                <MenuItem component={<Link to="/my-external-letters" />}>
                  مرسولات خارجی من
                </MenuItem>
              </SubMenu>
            )}

            <MenuItem component={<Link to="/preagent" />}>
              اخذ نمایندگی
            </MenuItem>

            <MenuItem component={<Link to="/support" />}>پشتیبانی</MenuItem>
            <MenuItem component={<Link to="/contact" />}>تماس با ما</MenuItem>
          </Menu>

          {isAuthed && (
            <Fragment>
              <div className={style.line} />
              <button
                onClick={() => {
                  handleExit();
                  setHambergerMenu(() => false);
                }}
                className={"d-flex bg-danger " + style.exitBtn}
              >
                <span>
                  <ImExit />
                </span>
                <span className="me-3">خروج</span>
              </button>
            </Fragment>
          )}
        </Sidebar>
      </div>

      {hambergerMenu === true && (
        <div
          className={style.backdrop}
          onClick={() => setHambergerMenu(() => false)}
        ></div>
      )}
    </div>
  );
}

export default NavbarSmall;
